import React, { useRef } from 'react';
import {
    DP_SEARCH_FORM_DATES_CLICK,
    DP_SEARCH_FORM_DEPARTURE_CLICK,
    DP_SEARCH_FORM_DESTINATION_CLICK,
    DP_SEARCH_FORM_ROOMS_CLICK,
    HSA_SEARCH_FORM_DATES_CLICK,
    HSA_SEARCH_FORM_DESTINATION_CLICK,
    HSA_SEARCH_FORM_ROOMS_CLICK,
    withClickTrack,
} from '../../utils/HtmlEvents';

export const SearchFormFieldsClickableWrapper = ({ children, onClick }) => {
    const isFirstInteraction = useRef(true);

    const _onClick = () => {
        if (isFirstInteraction.current) {
            onClick();
        }
        isFirstInteraction.current = false;
    };

    return <div onClick={_onClick}>{children}</div>;
};

export const ClickTrackArrival = withClickTrack(
    SearchFormFieldsClickableWrapper,
    HSA_SEARCH_FORM_DESTINATION_CLICK,
);

export const ClickTrackDates = withClickTrack(
    SearchFormFieldsClickableWrapper,
    HSA_SEARCH_FORM_DATES_CLICK,
);

export const ClickTrackRooms = withClickTrack(
    SearchFormFieldsClickableWrapper,
    HSA_SEARCH_FORM_ROOMS_CLICK,
);

export const ClickTrackDPDeparture = withClickTrack(
    SearchFormFieldsClickableWrapper,
    DP_SEARCH_FORM_DEPARTURE_CLICK,
);

export const ClickTrackDPArrival = withClickTrack(
    SearchFormFieldsClickableWrapper,
    DP_SEARCH_FORM_DESTINATION_CLICK,
);

export const ClickTrackDPDates = withClickTrack(
    SearchFormFieldsClickableWrapper,
    DP_SEARCH_FORM_DATES_CLICK,
);

export const ClickTrackDPRooms = withClickTrack(
    SearchFormFieldsClickableWrapper,
    DP_SEARCH_FORM_ROOMS_CLICK,
);
